export const countSearches = {
  analysisType: 'count',
  eventCollection: 'kb.search.view',
  key: 'countSearches',
}
